import { core } from '../core/index.js';
import { filterFabricErrors } from '../errors/errors.js';
/**
 * 打电话
 */
export type FabricUtilsCallPhoneNumberOptions = {
  /**
   * 手机号码
   */
  phone: string;
};

export type FabricUtilsCallPhoneNumberApi = (
  options: FabricUtilsCallPhoneNumberOptions
) => Promise<boolean>;

/**
 * 打电话, 此处需要动态获取用户授权, 如果用户拒绝授权下一次调用, 则返回协议字段 code='1' 标识,
 * 当前用户需要去设置页面打开授权.
 */
export const callPhoneNumber: FabricUtilsCallPhoneNumberApi = (
  options: FabricUtilsCallPhoneNumberOptions
) => {
  return new Promise<boolean>((resolve, reject) => {
    core.call<
      'fabric_utils.callPhoneNumber',
      FabricUtilsCallPhoneNumberOptions,
      boolean
    >('fabric_utils.callPhoneNumber', options, (result) => {
      const fabricErrors = filterFabricErrors(
        result.code,
        result.message,
        result.data
      );
      if (fabricErrors) {
        reject(fabricErrors);
      } else {
        resolve(result.data);
      }
    });
  });
};
